import androidx.compose.ui.platform.UriHandler

actual fun UriHandler.openBrowserWithUrl(url: String) {
    openUri(url)
}